import { Switch } from 'antd';
import type { SwitchProps } from 'antd';

export interface DSwitchProps extends SwitchProps {}

export const DarwinSwitch = (props: DSwitchProps) => {
  return <Switch {...props} />;
};